import { render, staticRenderFns } from "./polls.vue?vue&type=template&id=59c0edd3&scoped=true&"
import script from "./polls.vue?vue&type=script&lang=js&"
export * from "./polls.vue?vue&type=script&lang=js&"
import style0 from "./polls.vue?vue&type=style&index=0&id=59c0edd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c0edd3",
  null
  
)

export default component.exports